import * as Icons from "@phosphor-icons/react";
import { getGlobalStats, getSelectedBusinessId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Counter from "../Counter";
import DataStatuses from "const/DataStatuses";
import React from "react";
import UiRoutes from "const/UiRoutes";

const DocumentsUnpaidCounter = () => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const globalStats = useSelector(getGlobalStats);

  const businessId = useSelector(getSelectedBusinessId);

  const {
    documents: {
      toReview: { count = 0 } = {}
    } = {}
  } = globalStats;

  return (
    <Counter
      to={`/${businessId}${UiRoutes.DOCUMENTS}?status=${DataStatuses.TO_REVIEW}`}
      theme="primary"
      mainText={count}
      secondaryText={uiTexts.documents.toLowerCase()}
      description={messages.dashboardDocsNeedReview}
      icon={Icons.FileText}
      loading={!globalStats.documents} />
  );
};

export default React.memo(DocumentsUnpaidCounter);
